import React from 'react';
import '../styles/Global.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { 
      name: 'Facebook', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ), 
      url: '#' 
    },
    { 
      name: 'Instagram', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12c0-3.403 2.759-6.162 6.162-6.162s6.162 2.759 6.162 6.162-2.759 6.162-6.162 6.162-6.162-2.759-6.162-6.162zm1.621 0c0 2.507 2.034 4.541 4.541 4.541s4.541-2.034 4.541-4.541-2.034-4.541-4.541-4.541-4.541 2.034-4.541 4.541zm9.258-6.408c0 .795.646 1.44 1.44 1.44s1.44-.646 1.44-1.44-.646-1.44-1.44-1.44-1.44.646-1.44 1.44z"/>
        </svg>
      ), 
      url: '#' 
    },
    { 
      name: 'YouTube', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ), 
      url: '#' 
    },
    { 
      name: 'Twitter', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      ), 
      url: '#' 
    }
  ];

  const quickLinks = [
    { name: 'Home', url: '/' },
    { name: 'About Us', url: '/about' },
    { name: 'Courses', url: '/courses' },
    { name: 'Media', url: '/media' },
    { name: 'Dashboard', url: '/dashboard' }
  ];

  return (
    <footer className="footer" style={{ 
      backgroundColor: 'var(--text-dark)', 
      color: 'var(--secondary-color)',
      padding: '4rem 0 2rem'
    }}>
      <div className="container">
        <div className="footer-content">
          <div className="grid grid-4">
            {/* About Section */}
            <div className="footer-section">
              <h3 style={{ 
                color: 'var(--accent-color)', 
                marginBottom: '1.5rem',
                fontSize: '1.5rem'
              }}>
                Qyra Institute
              </h3>
              <p style={{ 
                lineHeight: '1.6', 
                marginBottom: '1.5rem',
                opacity: 0.9
              }}>
                Learn with Purpose. Grow with Knowledge. 
                Quality online education combining Islamic teachings with modern skills.
              </p>
              <div className="social-links">
                <h4 style={{ 
                  color: 'var(--secondary-color)', 
                  marginBottom: '1rem',
                  fontSize: '1rem'
                }}>
                  Follow Us
                </h4>
                <div style={{ display: 'flex', gap: '1rem' }}>
                  {socialLinks.map((social) => (
                    <a
                      key={social.name}
                      href={social.url}
                      title={social.name}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '40px',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        borderRadius: '50%',
                        color: 'var(--secondary-color)',
                        textDecoration: 'none',
                        transition: 'all 0.3s ease',
                        fontSize: '1.2rem'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = 'var(--accent-color)';
                        e.currentTarget.style.color = 'var(--text-dark)';
                        e.currentTarget.style.transform = 'translateY(-3px)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                        e.currentTarget.style.color = 'var(--secondary-color)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4 style={{ 
                color: 'var(--accent-color)', 
                marginBottom: '1.5rem',
                fontSize: '1.2rem'
              }}>
                Quick Links
              </h4>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                margin: 0
              }}>
                {quickLinks.map((link) => (
                  <li key={link.name} style={{ marginBottom: '0.75rem' }}>
                    <a
                      href={link.url}
                      style={{
                        color: 'var(--secondary-color)',
                        textDecoration: 'none',
                        opacity: 0.8,
                        transition: 'all 0.3s ease',
                        fontSize: '0.95rem'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.color = 'var(--accent-color)';
                        e.currentTarget.style.opacity = '1';
                        e.currentTarget.style.paddingLeft = '5px';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.color = 'var(--secondary-color)';
                        e.currentTarget.style.opacity = '0.8';
                        e.currentTarget.style.paddingLeft = '0';
                      }}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h4 style={{ 
                color: 'var(--accent-color)', 
                marginBottom: '1.5rem',
                fontSize: '1.2rem'
              }}>
                Contact Info
              </h4>
              <div style={{ lineHeight: '1.8' }}>
                <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '0.75rem', fontSize: '1.2rem' }}>📧</span>
                  <span style={{ fontSize: '0.95rem', opacity: 0.9 }}>
                    qyrainstitute@gmail.com
                  </span>
                </div>
                <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '0.75rem', fontSize: '1.2rem' }}>📞</span>
                  <span style={{ fontSize: '0.95rem', opacity: 0.9 }}>
                    0344-2614649
                  </span>
                </div>
                <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '0.75rem', fontSize: '1.2rem' }}>📍</span>
                  <span style={{ fontSize: '0.95rem', opacity: 0.9 }}>
                    Online - Worldwide
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '0.75rem', fontSize: '1.2rem' }}>🕐</span>
                  <span style={{ fontSize: '0.95rem', opacity: 0.9 }}>
                    Mon-Sat: 9:00 AM - 8:00 PM
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="footer-bottom" style={{ 
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          marginTop: '3rem',
          paddingTop: '2rem',
          textAlign: 'center'
        }}>
          <p style={{ 
            margin: 0,
            opacity: 0.8,
            fontSize: '0.9rem'
          }}>
            © {currentYear} Qyra Institute. All rights reserved. | 
            <a href="#" style={{ 
              color: 'var(--accent-color)', 
              textDecoration: 'none',
              margin: '0 0.5rem'
            }}>
              Privacy Policy
            </a> | 
            <a href="#" style={{ 
              color: 'var(--accent-color)', 
              textDecoration: 'none',
              margin: '0 0.5rem'
            }}>
              Terms of Service
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
